/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import type { ModelRegistry } from 'ember-data/types/registries/model';

interface IArgs {
  hideFaq?: true;
  booking: ModelRegistry['booking'];
}

interface BookingFooterSignature {
  Element: HTMLDivElement;

  Args: IArgs;
}

export default class UiBookingFooterV1Component extends Component<BookingFooterSignature> {
  @cached
  get booking(): ModelRegistry['booking'] {
    return this.args.booking;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Booking::Footer::V1': typeof UiBookingFooterV1Component;
  }
}
